var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
// import { DefaultComponentProps } from "@mui/material/OverridableComponent";
import { DialogContent, dialogContentClasses } from './dialog-content';
import MuiDialog from '@mui/material/Dialog';
import { DialogActions } from './dialog-actions';
import { DialogTitle } from './dialog-title';
import { useId } from '../utils/use-id';
import { styled } from '../styled';
export var dialogComponentName = 'QuantumDialog';
export var Root = styled(MuiDialog, {
    name: dialogComponentName,
    slot: 'Root',
})(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(dialogContentClasses.root)] = {
            paddingTop: theme.spacing(0.5),
        },
        _b);
});
export var Dialog = React.forwardRef(function (props, ref) {
    var title = props.title, actions = props.actions, children = props.children, onClose = props.onClose, idProp = props.id, disableBackdropClick = props.disableBackdropClick, _a = props.disableContentWrap, disableContentWrap = _a === void 0 ? false : _a, dialogProps = __rest(props, ["title", "actions", "children", "onClose", "id", "disableBackdropClick", "disableContentWrap"]);
    var id = useId(props.id);
    var titleId = !!title && !!id ? "".concat(id, "-title") : undefined;
    var handleClose = function (event, reason) {
        if (disableBackdropClick && reason === 'backdropClick') {
            return;
        }
        if (onClose) {
            onClose(event, reason);
        }
    };
    return (React.createElement(Root, __assign({ PaperProps: { elevation: 4 } }, dialogProps, { id: id, ref: ref, onClose: onClose ? handleClose : undefined, "aria-labelledby": titleId }),
        !!title && (React.createElement(DialogTitle, { id: titleId, onClose: onClose }, title)),
        disableContentWrap ? children : React.createElement(DialogContent, null, children),
        !!actions && React.createElement(DialogActions, null, actions)));
});
